<template>
  <v-container>
    <v-row>
      <v-col sm="6" offset-sm="3">
        <v-card v-scroll.self="onScroll" class="mx-auto overflow-y-auto" max-height="400px" color="#fff">
          <v-card-title>
            <v-icon large left color="#26c6da">mdi-twitter</v-icon>
          </v-card-title>
          <v-flex xs12>
            <Timeline :id="user_id" sourceType="profile" :options="{ tweetLimit: '3' }"/>
            <a class="twitter-timeline" data-lang="ja" data-dnt="true" href="https://twitter.com/nakeduranaiinfo?ref_src=twsrc%5Etfw">Tweets by nakeduranaiinfo</a>
          </v-flex>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Timeline } from "vue-tweet-embed";
export default {
  name: 'TweetEmbed',
  components: {
    Timeline
  },
  data: function() {
    return {
      user_id: "nakeduranaiinfo"
    };
  },
mounted() {
  setTimeout(() => {
    let tweetScript = document.createElement('script')
    tweetScript.setAttribute('src', 'https://platform.twitter.com/widgets.js')
    tweetScript.setAttribute('async', 'true')
    document.head.appendChild(tweetScript)
  }, 100)
}
};
</script>